import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';

export default (contract, queryGetOrders) => {
  const [getOrders, { loading, data, error, refetch }] = useLazyQuery(queryGetOrders);

  useEffect(() => {
    contract && contract.id && getOrders({ variables: { contractId: +contract.id } });
  }, [contract, getOrders]);

  return {
    loading,
    data,
    error,
    refetch,
  };
};
